<template>
  <div class="menu-item-images">
    <input type="file"
           style="display: none"
           name="newImage"
           accept="image/*"
           id="newImage"
           v-on:change="addFile($event)">
    <input type="hidden"
           id="images"
           name="images"
           v-model="imagesImploded">

    <div class="images"
         v-show="images && images.length > 0">
      <div class="image"
           v-for="(image, index) in images">
        <img :src="image"
             alt=""
        />
        <span @click="deleteImage(index)"
              class="delete-image">
					<i class="fas fa-times"></i>
				</span>
      </div>
    </div>

    <label for="newImage"
           class="button button-primary-outline">
      <i class="fas fa-circle-plus"></i>
      Upload image
    </label>

  </div>
</template>

<script>
export default {
  name: "ProductImages",
  props: ['product'],
  mounted() {

  },
  data: function () {
    return {

    }
  },
  computed: {
    images(){
      return this.product.images
    },
    imagesImploded() {
      return this.images.join('|||')
    }
  },
  methods: {
    addFile(event) {
      let fileReader = new FileReader();

      let file = event.target.files[0];

      if (!file) {
        return
      }

      fileReader.addEventListener("load", () => {
        // convert image file to base64 string
        this.images.push(fileReader.result)
      }, false);

      fileReader.readAsDataURL(file);

      $('#newImage')[0].file = null
    },
    deleteImage(index) {
      $.confirm({
        title: '',
        content: `<div style="font-size: 1.3em">Are you sure want to delete this image?</div>`,
        buttons: {
          confirm: {
            text: 'Ok',
            btnClass: 'btn btn-success',
            keys: ['enter'],
            action: () => {
              if (!this.product.id) {
                this.images.splice(index, 1);
                return;
              }

              axios.post(`/products/items/delete_image/${this.product.id}/image/${index}`).then(() => {
                this.images.splice(index, 1);
              })

            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn btn-danger',
            keys: ['esc', 'escape'],
          },
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
